{
  // Possible attributes for <swipe-marquee></swipe-marquee>

  // animate
  // animate-breakpoint="768" Activates only for screens smaller than 768px
  // animation-duration="40" Sets the animation duration to be 40s
  // duplicate-amount="3" Clones the amount of items x3
  // justify="center" Justifies the content to be centered
  // wrap="wrap" Adds flex wrap

  class SwipeMarquee extends HTMLElement {
    constructor() {
      super();

      this.container = this.querySelector(".swipe-marquee-wrapper");
      this.items = this.getElementsByClassName("swipe-marquee-item");
      this.paginateBtnsContainer = this.querySelector(".swipe-marquee-paginate-btns");

      this.timeout = null;
      this.sliderLeftPos = this.container.scrollLeft;

      const animationFinish = 100 / this.items.length;
      document.documentElement.style.setProperty(
        "--swipe-marquee-animation-finish",
        `translateX(-${animationFinish}%)`
      );
    }

    addBreakpoint() {
      const breakpoint = this.getAttribute("animate-breakpoint");

      if ((!breakpoint && this.getAttribute("animate")) || (breakpoint && window.innerWidth < breakpoint)) {
        this.container.classList.add("animate-swipe-marquee");
      }
    }

    setStyling() {
      if (this.getAttribute("justify")) {
        this.container.style.justifyContent = this.getAttribute("justify");
      }

      if (this.getAttribute("wrap")) {
        this.container.style.flexWrap = this.getAttribute("wrap");
      }
    }

    stopScroll() {
      if (this.container.scrollLeft == this.sliderLeftPos) return;
      this.sliderLeftPos = this.container.scrollLeft;

      this.container.classList.remove("animate-swipe-marquee");
      this.container.classList.add("scroll-snap-container");
      for (let i = 0; i < this.items.length; i++) {
        this.items[i].classList.add("scroll-snap");
      }

      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.container.classList.remove("scroll-snap-container");
        this.container.classList.add("animate-swipe-marquee");

        for (let i = 0; i < this.items.length; i++) {
          this.items[i].classList.remove("scroll-snap");
        }
      }, 2000);
    }

    addObserver(el, disablePagination) {
      if (disablePagination) return;

      let options = {
        root: this.container,
        rootMargin: "100% 0% 100% 0%",
        threshold: 1.0,
      };

      const observeIntersection = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const i = Array.from(el.parentNode.children).indexOf(el);
            const btn = this.getElementsByClassName("swipe-marquee-dot")[i];
            this.activatePaginationBtn(btn);
          }
        });
      };

      this.observer = new IntersectionObserver(observeIntersection, options);
      this.observer.observe(el);
    }

    activatePaginationBtn(btn) {
      const paginateBtns = this.getElementsByClassName("swipe-marquee-dot");
      for (let b = 0; b < paginateBtns.length; b++) {
        paginateBtns[b].classList.remove("swipe-marquee-active-dot");
      }

      btn.classList.add("swipe-marquee-active-dot");
    }

    duplicateItems() {
      const breakpoint = this.getAttribute("animate-breakpoint");
      const disablePagination = !this.paginateBtnsContainer || (breakpoint && window.innerWidth > breakpoint);

      const itemAmount = this.getAttribute("duplicate-amount")
        ? parseInt(this.getAttribute("duplicate-amount")) * this.items.length
        : this.items.length;

      for (let i = 0; i < itemAmount; i++) {
        this.addObserver(this.items[i], disablePagination);

        if (this.getAttribute("duplicate-amount")) {
          const itemClone = this.items[i].cloneNode(true);
          this.addObserver(itemClone, disablePagination);
          this.container.appendChild(itemClone.cloneNode(true));
        }

        if (disablePagination) return;

        const marqueeMemory = this;
        const newPaginateBtn = document.createElement("span");
        i === 0
          ? newPaginateBtn.classList.add("swipe-marquee-dot", "swipe-marquee-active-dot")
          : newPaginateBtn.classList.add("swipe-marquee-dot");

        newPaginateBtn.addEventListener("click", function () {
          this.parentElement.parentElement.stopScroll();
          this.parentElement.parentElement.activatePaginationBtn(newPaginateBtn, i);

          marqueeMemory.getElementsByClassName("swipe-marquee-item")[i].scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
          });
        });

        this.paginateBtnsContainer.appendChild(newPaginateBtn);
      }
    }

    addAnimation() {
      const breakpoint = this.getAttribute("animate-breakpoint");
      const duration = this.getAttribute("animation-duration") || 120;

      if ((!breakpoint && this.getAttribute("animate")) || (breakpoint && window.innerWidth < breakpoint)) {
        this.container.style.animationDuration = `${duration}s`;
      }
    }

    connectedCallback() {
      this.addAnimation();
      this.addBreakpoint();
      this.duplicateItems();
      this.setStyling();

      this.container.addEventListener("wheel", () => {
        this.stopScroll();
      });
    }
  }

  customElements.define("swipe-marquee", SwipeMarquee);
}
